<template lang="pug">
    v-card(
        elevation="4"
        shaped
        style="height: 500px !important;"
    )
        v-card-text
            v-sheet
                v-simple-table(style="width: 100%;")
                    template(v-slot:default)
                        tbody
                            tr
                                td.no-wrap.md-width.xs-height.task-border-right
                                    .d-flex.align-center
                                        .ml-2.mr-1.text-left
                                            .text-subtitle-1.font-weight-medium.volie-color-blue Waiting Messages
                                            .text-h4.font-weight-bold {{ currentBaseDashboardSummary.base_dashboard_summary.remaining_message_unresponded_conversation_group_count | number }}
                                        v-spacer
                                        .ml-auto
                                            v-icon.volie-color-blue(size="45")
                                                | mdi-clock

                                td.no-wrap.md-width.xs-height.task-border-left
                                    v-list.py-0(
                                        two-line
                                    )
                                        v-list-item
                                            v-list-item-content
                                                v-list-item-title.list-item-title-overflow {{ (currentBaseDashboardSummary.base_dashboard_summary.remaining_message_unresponded_average_wait_duration || 0) | secondsToFullWords }}
                                                v-list-item-subtitle Average Waiting

                                        v-list-item
                                            v-list-item-content
                                                v-list-item-title
                                                    strong {{ currentBaseDashboardSummary.base_dashboard_summary.remaining_message_unresponded_today_count | number }}
                                                v-list-item-subtitle From Today

            v-divider
            v-sheet(
                style="height: 307px;"
            )
                v-simple-table.table-x-scroll.px-md-3.pt-0.pb-md-3(
                    v-if="validDashboardSummaryConversationGroups"
                    style="width: 100%; height: 295px;"
                )
                    template(v-slot:default)
                        thead
                            tr.volie-background-color-blue
                                th.text-white
                                th.text-white Wait Time
                                th.text-white Organization
                                th.text-white Customer
                                th.text-white Affinity
                                th.text-white Active return message enrollment?
                                th.text-white Currently Assigned?
                        tbody.overflow-y-auto(style="height: 247px;")
                            tr(
                                v-for='conversationGroup in renderConversationGroups'
                                :key='conversationGroup.id'
                            )
                                td.text-center.no-wrap.xs-xs-width
                                    v-btn(icon light @click="openVmessage(conversationGroup);")
                                        v-icon mdi-cellphone
                                td.no-wrap.md-width
                                    template(v-if="(conversationGroup.waiting_duration || 0) < 600")
                                        strong {{ (conversationGroup.waiting_duration || 0) | secondsToFullWords }}

                                    v-tooltip(top v-else)
                                        template(v-slot:activator='{ on, attrs }')
                                            span(v-bind="attrs" v-on="on" role="text")
                                                Timeago(
                                                    :datetime="conversationGroup.waiting_created_at"
                                                    :auto-update="60"
                                                )
                                        span {{ (conversationGroup.waiting_duration || 0) | secondsToFullWords }}

                                td.no-wrap.md-width
                                    v-tooltip(top)
                                        template(v-slot:activator='{ on, attrs }')
                                            span(v-bind="attrs" v-on="on" role="text") 
                                                | {{ conversationGroup.organization_name | str_limit(25) }}
                                        span
                                            | {{ conversationGroup.organization_name }}
                                td.no-wrap.md-width
                                    v-tooltip(top)
                                        template(v-slot:activator='{ on, attrs }')
                                            span(v-bind="attrs" v-on="on" role="text") 
                                                | {{ conversationGroup.customer_full_name | str_limit(25) }}
                                        span
                                            | {{ conversationGroup.customer_full_name }}
                                td.no-wrap.md-width
                                    v-tooltip(top v-if="conversationGroup.affinity && conversationGroup.affinity.length > 0")
                                        template(v-slot:activator='{ on, attrs }')
                                            span(v-bind="attrs" v-on="on" role="text") 
                                                | {{ conversationGroup.affinity | str_limit(25) }}
                                        span
                                            | {{ conversationGroup.affinity }}
                                    template(v-else) ---
                                td.no-wrap.md-width
                                    strong.text-uppercase.success--text(v-if="conversationGroup.campaign_customer_active_id > 0") YES
                                    strong.text-uppercase.error--text(v-else) NO

                                td.no-wrap.md-width
                                    v-tooltip(v-if="conversationGroup.assigned_to > 0" top)
                                        template(v-slot:activator='{ on, attrs }')
                                            span(v-bind="attrs" v-on="on" role="text") 
                                                | {{ conversationGroup.user_full_name | str_limit(25) }}
                                        span
                                            | {{ conversationGroup.user_full_name }}
                                    strong.text-uppercase.error--text(v-else) NO

                .px-4.py-1(v-else)
                    v-alert(type="success" dense)
                        | Zero wait times

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    export default Vue.extend({
        data() {
            return {
                limit: 100,
                renderConversationGroups: [],
            }
        },
        methods: {
            buildRender() {
                for (let i = 0; i < this.dashboardSummaryConversationGroups.length; i++) {
                    this.renderConversationGroups.push(this.dashboardSummaryConversationGroups[i]);

                    // this may need to change
                    if ((i + 1) === this.limit) {
                        break;
                    }
                }
            },
        },
        computed: {
            validDashboardSummaryConversationGroups() {
                return this.dashboardSummaryConversationGroups?.length > 0;
            },
            validBaseDashboardSummary() {
                return this.currentBaseDashboardSummary?.base_dashboard_summary?.id > 0;
            },
        },
        components: {
        },
        props: {
            currentBaseDashboardSummary: Object,
            dashboardSummaryConversationGroups: Array,
            openVmessage: Function,
        },
        watch: {
        },
        destroyed() {
        },
        created() {
            this.buildRender();
        },
    });
</script>

<style lang="scss" scoped>
</style>